import { rpcClient } from '../rpcClient/rpcClient';
import { validatePortalForGrowthProPlusExposureRpc } from '../../__generated__/chirp/com/hubspot/growth/post/purchases/rpc/server/GrowthPostPurchasesChirpService';
export const fetchIsPlpoEnrolled = async () => {
  const response = await rpcClient.call(validatePortalForGrowthProPlusExposureRpc, {});
  return Boolean(response === null || response === void 0 ? void 0 : response.valid);
};